import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propOneOf, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitSolution from './ProfessionalUnitSolution';
const ProfessionalUnitSolutionWrapper = (props) => {
    const { item, itemClassName, showAlertModal, userMode } = props;
    if (!item) {
        return null;
    }
    return (_jsx(ProfessionalUnitSolution, { itemClassName: itemClassName, showAlertModal: showAlertModal, solution: item, userMode: userMode }));
};
ProfessionalUnitSolutionWrapper.propTypes = {
    item: propShape(),
    itemClassName: propStr(),
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitSolutionWrapper.defaultProps = {
    item: undefined,
    itemClassName: '',
};
export default ProfessionalUnitSolutionWrapper;
